import { getGtmAttr, GTM_NOTSET_INTEGER, GTM_NOTSET_STRING } from '@musinsa/frontend-utils';

import type { GiftProduct } from '@/shared/@types';

export const gtmGift = {
  GoodsItem: (index: number, gtmProps?: GiftProduct) =>
    getGtmAttr(['view_item_list', 'select_item'], {
      item_list_id: 'gift_detail',
      item_list_index: index.toString(),
      item_id: String(gtmProps?.goodsNo) ?? GTM_NOTSET_INTEGER,
      item_name: gtmProps?.goodsName ?? GTM_NOTSET_STRING,
      original_price: gtmProps?.couponPrice ?? gtmProps?.price ?? GTM_NOTSET_INTEGER,
      item_brand: gtmProps?.brandName ?? GTM_NOTSET_STRING,
      discount_rate: String(gtmProps?.couponSaleRate ?? gtmProps?.saleRate ?? GTM_NOTSET_STRING),
      price: gtmProps?.couponPrice ?? gtmProps?.price ?? GTM_NOTSET_INTEGER,
      quantity: GTM_NOTSET_INTEGER,
      discount: gtmProps?.couponSaleRate ?? gtmProps?.saleRate ?? GTM_NOTSET_INTEGER,
    }),
  More: () =>
    getGtmAttr(['click_button'], {
      section_name: 'gift_detail',
      section_index: '24',
      button_id: 'more',
      button_name: '적용상품더보기',
      brand_id: GTM_NOTSET_STRING,
      index: GTM_NOTSET_STRING,
    }),
};
